var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveStyle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.8 49.48 35.8 58.75 32.64 58.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.44,33.9c-8.25-3.47-14.01-10.61-13.1-16.25.59-3.64,3.6-6.18,7.33-6.18,2.61,0,4.8,1.16,6.18,3.19,1.37-2.03,3.57-3.19,6.17-3.19,3.73,0,6.75,2.54,7.33,6.18.91,5.64-4.84,12.78-13.1,16.25l-.41.17-.41-.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveStyle);
export default __webpack_public_path__ + "static/media/love-style.c54bfa78f6d246bf13d0070caae0c031.svg";
export { ForwardRef as ReactComponent };